import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { connect } from 'react-redux';
import SongTrackLoader from '../loader/songTrackLoader';
import SongTrack from '../songTrack/songTrack';
import * as songActions from '../../store/song/actions';
import { showLoading, hideLoading } from 'react-redux-loading-bar';

const HOME_PREVIEW_COUNT = 6;

/**
 * Generic home-page rail for any single recommendation section (hidden
 * gems, collaborative, trending today, etc.) — backed by
 * POST /v1/recommendation/get-section-recommendations.json. Shows a
 * 6-song preview (matching other compact home-page rows) with a "View All"
 * link to the full section at /mp3/recommendation/:section. Renders
 * nothing once loaded if the section came back empty (e.g. collaborative
 * for a customer with no download history yet).
 *
 * Usage: <HomeRecommendationSection section="hidden_gems" title="Hidden Gems" />
 */
const HomeRecommendationSection = ({ section, title, getSectionRecommendations, sectionData, displayLoading, hideLoading }) => {

    useEffect(() => {
        loadData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [section]);

    const loadData = async () => {
        displayLoading();
        await getSectionRecommendations(section);
        hideLoading();
    }

    const songs = sectionData && sectionData.songs ? sectionData.songs : null;

    if (songs && songs.length === 0) {
        return null;
    }

    const previewSongs = songs ? songs.slice(0, HOME_PREVIEW_COUNT) : null;

    return (
        <div className="play-list-sec d-none" style={{display: 'none'}}>
            <div className="top-heading">
                <h2><Link to={`/mp3/recommendation/${section}`}>{title}</Link></h2>
            </div>
            {
                previewSongs ?
                    <div className="inner-block">
                        <SongTrack songs={previewSongs} sectionName={`recommendation-${section}`} displayDates={true} />
                    </div>
                : <SongTrackLoader itemCount={HOME_PREVIEW_COUNT} />
            }
            {
                songs && songs.length > HOME_PREVIEW_COUNT ?
                    <Link className="primary-btn view-all-genres-btn" to={`/mp3/recommendation/${section}`}>View All</Link>
                : ''
            }
        </div>
    );
}

function mapStateToProps(state, ownProps) {
    return {
        sectionData: state.song.sectionRecommendations ? state.song.sectionRecommendations[ownProps.section] : null,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        getSectionRecommendations: (section) => dispatch(songActions.getSectionRecommendations(section)),
        displayLoading: (sectionBar) => dispatch(showLoading(sectionBar)),
        hideLoading: (sectionBar) => dispatch(hideLoading(sectionBar)),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(HomeRecommendationSection);
